import React, { useState } from "react";
import { PROMPT_VARIABLES } from "./PromptVariables";
import PromptVariableSidebar from "./PromptVariableSidebar";

export default function PromptEditor({
  value,
  onChange,
  currentProtocol,
  handleProtocolChange,
}) {
  return (
    <div className="flex h-full overflow-hidden">
      {currentProtocol ? (
        <PromptVariableSidebar
          className="h-full overflow-y-auto"
          currentProtocol={currentProtocol}
          handleProtocolChange={handleProtocolChange}
          onInsert={(variableKey) => {
            const el = document.getElementById("prompt-editor-textarea");
            if (!el) return;
            const start = el.selectionStart;
            const end = el.selectionEnd;
            const currentTextValue = el.value;
            const newValue =
              currentTextValue.slice(0, start) +
              `{${variableKey}}` +
              currentTextValue.slice(end);
            onChange(newValue);
            requestAnimationFrame(() => {
              el.focus();
              const newCursorPos = start + variableKey.length + 2;
              el.selectionStart = el.selectionEnd = newCursorPos;
            });
          }}
        />
      ) : (
        <div className="w-80 bg-white border-r border-gray-200 h-full flex items-center justify-center text-gray-500">
          Loading...
        </div>
      )}
      <div className="flex-1 flex flex-col h-full">
        <div className="flex-1 relative p-2 h-full overflow-hidden">
          <textarea
            id="prompt-editor-textarea"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-full resize-none p-2 rounded bg-transparent outline-none overflow-auto font-mono text-sm leading-relaxed"
            placeholder="Enter prompt template... Use {variables} from the sidebar."
            spellCheck="false"
          />
        </div>
      </div>
    </div>
  );
}
